export interface NavItem {
  to: string;
  label: string;
}

export const navItems: NavItem[] = [
  { to: "/", label: "首页" },
  { to: "/news", label: "新闻" },
  { to: "/video", label: "视频" },
  { to: "/encyclopedia", label: "百科" },
  { to: "/hotsearch", label: "热门搜索" },
  { to: "/about", label: "关于" },
];